import { useAxios, useSubjectId } from '@healthblocks-io/core'
import { useCallback } from 'react'

import type { CreateOrderRequest, OrderResponse } from '../types/order.type'

export function useOrders() {
  const axios = useAxios()
  const subjectId = useSubjectId()

  const getOrderById = useCallback(
    (orderId: number) => {
      return axios.get<OrderResponse>(`/order/${orderId}?subjectId=${subjectId}&include=orderLines`)
    },
    [axios, subjectId],
  )

  /**
   * Create an order
   * @param order - The order to create
   * @param includePaymentLink - Whether to include the payment link in the response
   * @returns The created order
   */
  const createOrder = useCallback(
    (order: CreateOrderRequest, includePaymentLink = true) => {
      return axios.post<OrderResponse>(`/order?includePaymentLink=${includePaymentLink}`, {
        ...order,
        subjectId,
      })
    },
    [axios, subjectId],
  )

  return {
    getOrderById,
    createOrder,
  }
}
